export interface PerformanceItem {
  color: string
  goal_value: number
  percent_value: number
  missed?: number
}

export interface IscPerformanceState {
  COHORT: string
  COHORT_TYPE: string
  DBT_UPDATED_AT: string
  APPOINTMENTS_KEPT: PerformanceItem
  RESPONSE_TIME_ASSIGNED_TO_CONTACT: PerformanceItem
  INBOUND_CALLS_ANSWERED: PerformanceItem
  INBOUND_CHATS_ANSWERED: PerformanceItem
  LEADS_WITH_APPOINTMENT_SET: PerformanceItem
  RESPONSE_TIME_QUEUE_TO_ASSIGNED: PerformanceItem
  SALES_WITH_ISC_ATTACHED: PerformanceItem
  QUALITY: PerformanceItem
}

export const PERFORMANCE_TIMEFRAMES = {
  t7d: 'Last 7 Days',
  MTD: 'MTD',
  QTD: 'QTD'
}
